import { assertLegacyMonetaryClientAvailable } from "@/services/legacyMonetaryBoundary";

const rejectBrowserMonetaryAuthority = async () => {
  assertLegacyMonetaryClientAvailable();
};

export default {
  namespaced: true,
  state: {
    currentAccountBalance: 0,
  },
  getters: {
    getCurrentAccountBalance: (state) => state.currentAccountBalance,
  },
  mutations: {
    UPDATE_ACCOUNT_BALANCE(state, balance) {
      state.currentAccountBalance = balance;
    },
  },
  actions: {
    // Compatibility action names remain while their callers migrate to
    // quote/settlement commands. None may read or mutate Wallet state in the
    // browser, even when the private monetary feature gates are still off.
    getOrgData: rejectBrowserMonetaryAuthority,
    getUserWalletData: rejectBrowserMonetaryAuthority,
    updateWallet: rejectBrowserMonetaryAuthority,
    createCoin: rejectBrowserMonetaryAuthority,
    handleTransaction: rejectBrowserMonetaryAuthority,
  },
};
